import getConfig from 'next/config';
import { viewItemListAnalytics } from '../../../../util/gtm';
import { getCookie, setCookie } from '../../../hooks/useCookie';
import getCarts from '../../../integration/cart.api';
import { getHandsets } from '../../../integration/handset.api';
import { CART_TYPE, OFFER_TYPE_CODE } from '../../shared/Constants';

const { publicRuntimeConfig } = getConfig();
const { NEW_ACQUISITION } = CART_TYPE;
const { PREPAY } = OFFER_TYPE_CODE;

/**
 * @function getStandalonePrepayHandsets - function to get handset lists for prepay
 * @param {*} graphql - From useApolloClient
 * @returns {object} - List of handsets
 */
export const getStandalonePrepayHandsets = async ({ graphql }) => {
  try {
    let variable = {};
    if (getCookie('reference') && getCookie('STANDALONE_HANDSET') === 'false') {
      const { getCart: cart } = await getCarts({
        graphql,
        variables: { reference: getCookie('reference') },
      });

      const hasPrepayIncart = cart?.offers[0]?.addOns?.length > 0;
      const cartOfferId = cart?.offers[0]?.id;
      if (hasPrepayIncart) {
        variable = {
          offerType: PREPAY,
          cartOfferID: cartOfferId,
          cartType: getCookie('cart_Type') || NEW_ACQUISITION,
          reference: getCookie('reference'),
        };
        const result = await getHandsets({ graphql, variables: variable });
        viewItemListAnalytics('Prepay_handsets', result);
        return { result };
      }
    } else {
      setCookie('PREPAY', 'STANDALONE_HANDSET', true);
      variable = {
        offerType: PREPAY,
        channel: getCookie('channel')
          ? getCookie('channel')
          : `${publicRuntimeConfig.NEXT_PUBLIC_CHANNEL}`,
        cartOfferID: getCookie('HANDSET_BE_OFFERID')
          ? parseInt(getCookie('HANDSET_BE_OFFERID'), 10)
          : null,
        cartType: getCookie('cart_Type') || NEW_ACQUISITION,
        reference: getCookie('reference'),
      };
      if (!getCookie('reference')) {
        delete variable.reference;
      }
      if (!variable.cartOfferID) delete variable.cartOfferID;

      const result = await getHandsets({ graphql, variables: variable });

      if (!getCookie('reference')) {
        setCookie('PREPAY', 'reference', result?.getHandsets?.reference);
      }
      if (!getCookie('cart_Type')) {
        setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
      }

      viewItemListAnalytics('Prepay_handsets', result);
      setCookie('PREPAY', 'HANDSET_BE_OFFERID', result?.getHandsets?.cartOfferID);
      return { result };
    }
  } catch (err) {
    console.error(err);
    return { error: err };
  }
};

/**
 * @function onLoadPrepayHandset - Onload function on handsets page
 * @param {graphql} graphql - From useApolloClient
 * @param {function} setState - From useApolloClient
 * @param {object} state - Contains local state of the container
 * @param {fucntion} setLoader - Sets the loader to display skeleton
 * @param {function} setOnLoadError - Sets the error onload of the page when API is failed
 * @param {function} setErrorModalOccurence - Sets the error modal occurence
 * @param {string} errorModalOccurence -Error modal occurences
 * @param {function} setOpenError - Function which sets error on API failure
 * @param {function} openAPIFailureModal - Triggers API error modal
 * @returns {object} - List of handsets
 */
export const onLoadPrepayHandset = async ({
  graphql,
  setState,
  state,
  setLoader,
  setOnLoadError,
  setErrorModalOccurence,
  errorModalOccurence,
  setOpenError,
  openAPIFailureModal,
  errorModal,
  rootState,
  dispatch,
}) => {
  dispatch({ type: 'ENABLE_FOOTER', payload: false });
  setLoader(true);
  const { result, error } = await getStandalonePrepayHandsets({
    graphql,
    rootState,
  });
  if (result && !error) {
    setOpenError(false);
    setErrorModalOccurence(0);
    errorModal.disable();
    openAPIFailureModal.disable();
    setState({
      ...state,
      devices: result?.getHandsets?.handsets,
      brands: result?.getHandsets?.manufacturers,
    });
  } else {
    setOpenError(true);
    errorModal.enable();
    setErrorModalOccurence(errorModalOccurence + 1);
    openAPIFailureModal.enable();
    setOnLoadError(true);
    if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
    if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
    if (!getCookie('token-missing') && !getCookie('found-403'))
      setErrorModalOccurence(errorModalOccurence + 1);
    if (!getCookie('found-403')) errorModal.enable();
    if (!getCookie('token-missing')) errorModal.enable();
    console.error('something went wrong getting handsets,', error);
  }

  setLoader(false);
};
